import React, { Component, RefObject } from 'react';
import styles from './flex-set-tile.scss';
import FspTileDetails from './flexSetTileDetail/fspTileDetails';
import { IBrickItem, IFlexibleSetTileProps } from './flex-set-tile.d';
import TabNavigationHelper from '../../../Common/tabNavigationHelper';
import FlexSetImagesGrid, { IFlexSetImageFileData } from '../../flexSets/flexSetTile/flexSetImagesGrid/flexSetImagesGrid';
import classNames from 'classnames';

export default class FlexSetTile extends Component<IFlexibleSetTileProps, {
    isHovering: boolean,
    isTouchAction: boolean,
    itWasTouchMove: boolean,
    mounted: boolean
}> {
    private hoverStartupTimer: ReturnType<typeof setTimeout>;
    private elementRef: RefObject<HTMLDivElement>;
    private tabNav: TabNavigationHelper;
    private images: IFlexSetImageFileData[];
    private freeImages: IFlexSetImageFileData[];
    private mainImage: IFlexSetImageFileData;
    private discount?: number;
    constructor(props) {
        super(props);

        this.state = {
            isHovering: false,
            isTouchAction: false,
            itWasTouchMove: false,
            mounted: false,
        };

        this.tabNav = TabNavigationHelper.instance;

        this.onMouseEnter = this.onMouseEnter.bind(this);
        this.onMouseLeave = this.onMouseLeave.bind(this);
        // this.changeColorVariant = this.changeColorVariant.bind(this);
        // this.toggleAvailableSizes = this.toggleAvailableSizes.bind(this);
        this.resetTouchEventState = this.resetTouchEventState.bind(this);
        // this.handleTileClick = this.handleTileClick.bind(this);
        this.handleOnMouseDown = this.handleOnMouseDown.bind(this);
        this.handleKeyDown = this.handleKeyDown.bind(this);

        // const tileId = 'ats-'+ this.props.flexibleSet.fsCode.toString()
        // + (isTeaserView ? `_${this.props.gridNumber}` : '');
        // this.props.article.tileId = tileId;
        // the parent page component will need to have a ref to the DOM for each article
        // to do scroll distance calculations

        // TODO: might be a problem with tile reuse
        this.elementRef = React.createRef<HTMLDivElement>();
        // this.props.article.elementRef = this.elementRef;
        this.mainImage = {
            fullPath: this.props.flexibleSet.flexibleSetImageFullPath,
            imageAlt: this.props.flexibleSet.salesDesignation,
            quantity: 0, // no point for quantity
        }

        this.images = new Array<IFlexSetImageFileData>;
        this.freeImages = new Array<IFlexSetImageFileData>;
        this.props.flexibleSet.sortedBricks.map((brick) => {
            let mainBrickItem = {} as IBrickItem;
            if (brick.items.length > 1) { // we have multiple brick items, find the main one
                mainBrickItem = brick.items.find((item) => item.mainBrickItem);
            }
            else {
                mainBrickItem = brick.items[0]; // we receive only on brick item and it is the main one
            }

            const imageFile: IFlexSetImageFileData = {
                fullPath: mainBrickItem.imageFullPath,
                imageAlt: mainBrickItem.altTagForImage,
                quantity: mainBrickItem.quantity,
            }
            if (brick.isFree) {
                this.freeImages.push(imageFile);
            } else {
                this.images.push(imageFile);
            }
        });
        if (this.props.setPrice.discountType !== FlexibleSetDiscountType.FreeItem) {
            this.discount = this.props.setPrice.discountPercentage;
        }
    }

    componentDidMount(): void {

        if (this.elementRef.current)
            this.tabNav.setFocusAtt(this.elementRef.current);
        // if(this.props.article.elementRef.current)
        // this.tabNav.setFocusAtt(this.props.article.elementRef.current);

        // for tablet devices:
        this.setState({
            // isDesktop: window.innerWidth > this.breakpoint_tablet_max_width_1199,
            mounted: true
        });
    }

    componentDidUpdate(): void {
        // react will reuse a component (based on key in parent) when we get new articles after filtering
        // so articles that were present before filtering already and stay after filtering will
        // receive new props (new but equal ISalesDesignationView from backend),
        // we copy the element ref into it
        /*
        if (!this.props.article.elementRef && this.elementRef) {
            this.props.article.elementRef = this.elementRef;
        }*/
    }

    componentWillUnmount(): void {
        this.setState({
            mounted: false
        });
    }

    /*
    private get isNonDesktopDevice() {
        return this.props.isMobile || isTablet || !this.state.isDesktop;
    }*/

    /*
    private handleTileClick(tileId: string, pageNo: number): void {
        this.props.urlController.updateUrlForPaging(pageNo, tileId);
    }*/

    private onMouseEnter(): void {
        clearTimeout(this.hoverStartupTimer);

        this.hoverStartupTimer = setTimeout(() => {
            this.startHover();
        }, 1000);
    }

    private startHover(): void {
        this.setState({ isHovering: true });
    }

    private onMouseLeave(): void {
        this.restoreAccessability();
        clearTimeout(this.hoverStartupTimer);

        this.setState({
            isHovering: false,
        });
    }

    private preventDefaultEvents(e?): void {
        if (e) {
            e.preventDefault(); //the ArticleTile has a <a>-tag to link to PDP, we want to avoid navigation here
            e.stopPropagation();
            e.nativeEvent.stopImmediatePropagation();
            e.nativeEvent.stopPropagation();
        }
    }

    private openHoverContentByTouch(): void {
        if (this.props.isMobile && !this.props.isDesktop)
            return;

        if (this.state.isHovering && !this.state.itWasTouchMove)
            window.location.href = this.props.flexibleSet.fspLink;
        else if (!this.state.itWasTouchMove)
            this.startHover();

        // if it was not movement, on next click pdp will be opened
        this.setState({ itWasTouchMove: false });
    }

    private getPdpLink(): string {
        const pdpLink = this.props.addItemOriginToPdpLink ?
            this.props.flexibleSet.fspLink + '?itemorigin=SEARCH' : this.props.flexibleSet.fspLink;
        if (this.props.isMobile || !this.state.isTouchAction)
            return pdpLink;
    }

    private getTotalArticleCount(): number {
        let totalCount = 0;
        this.props.flexibleSet.sortedBricks.map((brickItem) => {
            let mainBrickItem = {} as IBrickItem;
            if (brickItem.items.length > 1) { // we have multiple brick items, find the main one
                mainBrickItem = brickItem.items.find((item) => item.mainBrickItem);
            }
            else {
                mainBrickItem = brickItem.items[0]; // we receive only on brick item and it is the main one
            }
            totalCount += mainBrickItem.quantity;
        })
        return totalCount;
    }

    private resetTouchEventState(event): void {
        // from mobile up to regular tablet, we should keep regular click event
        // feature. But for Kiosk, and High res., tablets, we need first show 
        // hover effect (variants and available sizes) and only on second click
        // proceed with regular event
        if (this.state.isTouchAction && this.props.isDesktop) {
            event.preventDefault();
        }

        this.setState({ isTouchAction: false });
    }

    // prevent image fro drag, used it ArticleTile List fragment, but does not harm regular features too:
    private handleOnMouseDown(event): void {
        event.preventDefault();
    }

    private handleKeyDown(event): void {
        // prevent page jump down when 3dG is closed with Space btn., click
        if (event.key === ' ') { // space btn
            event.preventDefault();
            // event.target is article tile root element article_tile
            this.tabNav.removeFocusAtt(event.target);
            this.tabNav.setGroupAtt(event.target);
            this.tabNav.setModalAtt(event.target);

            const fas_slides = event.target.querySelector('.fas_slides');
            this.tabNav.setFocusAtt(fas_slides);
            window.shell.tabNav.focus(fas_slides);
            this.startHover();
        }

        if (event.key === 'Escape') {
            event.preventDefault();
            this.onMouseLeave();
            window.shell.tabNav.focus(this.elementRef.current, 'keyboard');
        }

        if (event.key === 'Enter') {
            event.preventDefault();
            window.location.href = this.getPdpLink();
        }

        if (!window.shell.tabNav)
            return;

        if (event.key === 'ArrowRight' && event.target.nextSibling) {
            window.shell.tabNav.focus(event.target.nextSibling);
        }

        if (event.key === 'ArrowLeft' && event.target.previousSibling) {
            window.shell.tabNav.focus(event.target.previousSibling);
        }
    }

    private restoreAccessability(): void {
        if (!this.elementRef.current)
            return; // exit if source element is not available

        const idv_container = this.elementRef
            .current.querySelector('.fas_idv_container');

        // event.target is fas_idv_container
        this.tabNav.removeFocusAtt(idv_container);

        this.tabNav.removeGroupAtt(this.elementRef.current);
        this.tabNav.setFocusAtt(this.elementRef.current);
    }

    public render() {
        return (
            <div id={this.props.flexibleSet.fsCode}
                ref={this.elementRef}
                className={classNames(styles.article_tile, {
                    // We only want to add this for newly loaded sets after pressing the "show more" button
                    // It forces a small transition animation/delay to minimize flickers and make the UI 
                    // update smoother.
                    [styles.initial]: this.props.isClientSide && !this.state.mounted
                })}
                data-testid='article_tile'
                onMouseEnter={this.props.isMobile || !this.props.isDesktop ? () => { return false; } : this.onMouseEnter}
                onMouseLeave={this.props.isMobile && !this.props.isDesktop ? () => { return false; } : this.onMouseLeave}
                onMouseDown={this.props.isDesktop ? this.handleOnMouseDown : undefined}
                onKeyDown={this.handleKeyDown}
            >
                <a className='hidden return-anchor' href={'#' + this.props.flexibleSet.fsCode}
                    aria-label={'return anchor for article ' + this.props.flexibleSet.fsCode} />
                <a href={this.getPdpLink()}
                    className={styles.idv_container}
                    data-testid='idv_container'
                    onTouchMove={() => {
                        this.setState({ itWasTouchMove: true });
                    }}
                    onTouchEnd={() => this.openHoverContentByTouch()}
                    onTouchStart={() => {
                        this.setState({ isTouchAction: true });
                    }}
                    onClick={(event) => this.resetTouchEventState(event)}
                >
                    <div className={styles.media_container}>
                        <FlexSetImagesGrid
                            on_hover={this.state.isHovering}
                            detailsPageLink={this.props.flexibleSet.fspLink}
                            isMobile={this.props.isMobile}
                            preventDefaultEvents={this.preventDefaultEvents}
                            categoryName={this.props.category.categoryName}
                            images={this.images}
                            fspImage={this.mainImage}
                            gratisImages={this.freeImages}
                            setDiscount={this.discount}
                            l10n={this.props.l10n}
                            totalArticleCount={this.getTotalArticleCount()}
                        />
                    </div>
                    <div className={styles.dv_container}>
                        <FspTileDetails
                            currencyInformation={this.props.currencyInformation}
                            description={this.props.flexibleSet.salesDesignation}
                            isMobile={this.props.isMobile}
                            isGlobal={this.props.isGlobal}
                            setPrice={this.props.setPrice}
                        />
                    </div>
                </a>
            </div>
        );
    }
}

export enum FlexibleSetDiscountType {
    DynamicPrice,
    FixedPrice,
    FreeItem,
}
